import React from 'react';
import { Badge, makeStyles, Theme } from '@material-ui/core';
import { colorSet } from '@components/Provider';

interface UpdateBadgeProps {
  children: React.ReactNode;
  top?: number;
  right?: number;
  invisible?: boolean;
}

const UpdateBadge = ({
  children,
  top = 6,
  right = -8,
  invisible = true
}: UpdateBadgeProps) => {
  const { root } = useStyles({ top, right });
  return (
    <Badge className={root} variant={'dot'} invisible={invisible}>
      {children}
    </Badge>
  );
};

export default UpdateBadge;

const useStyles = makeStyles<Theme, Omit<UpdateBadgeProps, 'children'>>(() => ({
  root: {
    '& .MuiBadge-dot': {
      minWidth: 6,
      height: `6px !important`,
      top: ({ top }) => `${top}px !important`,
      right: ({ right }) => `${right}px !important`,
      backgroundColor: `${colorSet.errorBase} !important`
    }
  }
}));
